import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_25: FaireProductEntity = {
  token: "starter_collection_25",
  type: "product",
  name: "Rapture Blackberry Balsamic",
  brandName: "Brightland",
  imageUrl: "",
  priceDollars: 29,
  msrpDollars: 58,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
